<div class="py-4 mb-8">
    <p-iftalabel>
        <textarea class="w-full" pTextarea rows="2" [autoResize]="true" pInputText id="shopperNotes" [(ngModel)]="shopperNotes"
        placeholder="Add any notes about this item for customer"></textarea>
        <label for="shopperNotes">Shopper Notes</label>
    </p-iftalabel>

    <div class="absolute z-10 bottom-0 right-0 left-0 h-12 w-full bg-green-100">
        <div>
            <p-button
                [label]="'Save Notes'"
                [text]="true"
                [size]="'large'"
                severity="success"
                (click)="saveNotes()"
                [disabled]="!shopperNotes"
                [style]="{background: '#4D7935', width: '100%', 'border-radius': '0'}"
                class="[&_button]:text-white [&_button]:w-full [&_.p-button-icon]:text-md" />
        </div>
    </div>
</div>
